import React from "react";
import i18n from "../../../../i18nextInitiator";
import {connect} from "react-redux";
import SingleSnackbar from "./SingleSnackbar";
import {
    CHANGE_AUTH_CODE,
    CHANGE_AUTH_PHONE, CHANGE_PROFILE_INPUT,
    HIDE_AUTH_ALERT, HIDE_DELETE_ALERT,
    HIDE_ERROR_ALERT, HIDE_ORDER_ALERT,
    HIDE_SUCCESS_ALERT,
    HIDE_WARNING_ALERT, LOGOUT, SHOW_PHONE_ALERT
} from "../../../../actions/actionsTypes";
import convertDigits from "../../../../components/convertDigits";
import {
    cancelOrder,
    login,
    resetState,
    sendVerificationCode,
    storeProfile,
    submitAuthCode
} from "../../../../actions/actionCreators";
import {goBack, push} from "connected-react-router";

/**
 * The Specific translate function for this namespace
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa', 'general');
/**
 * Redux States.
 * @param state
 */
const mapStateToProps = state => ({...state});
const mapDispatchToProps = dispatch => ({
    hideErrorAlert: ()=>{dispatch({type: HIDE_ERROR_ALERT})},
    hideSuccessAlert: ()=>{dispatch({type: HIDE_SUCCESS_ALERT})},
    hideAuthAlert: ()=>{dispatch({type: HIDE_AUTH_ALERT})},
    hideWarningAlert: ()=>{dispatch({type: HIDE_WARNING_ALERT})},
    hideOrderAlert: ()=>{dispatch({type: HIDE_ORDER_ALERT})},
    hideDeleteAlert: ()=>{dispatch({type: HIDE_DELETE_ALERT})},
    changeAuthPhone: e =>{dispatch({type: CHANGE_AUTH_PHONE, value:convertDigits(e.target.value).replace(/\D/g, '')})},
    changeAuthCode: e =>{dispatch({type: CHANGE_AUTH_CODE, value:convertDigits(e.target.value).replace(/\D/g, '')})},
    showPhoneAlert: e =>{dispatch({type: SHOW_PHONE_ALERT})},
    changeProfileInput: e => {dispatch({type: CHANGE_PROFILE_INPUT, value: e.target.value, name: e.target.name})},
    resetState,
    submitAuthCode,
    sendVerificationCode,
    login,
    cancelOrder,
    logout: () => {
        dispatch({type: LOGOUT})
        dispatch((push("/")))
    },
    storeProfile,
    lastStep: () => dispatch(goBack()),
});
const Snackbars = props => {

    const {
        hideSuccessAlert,
        hideWarningAlert,
        hideErrorAlert,
        order: {
            successAlert,
            successAlertMessage,
            warningAlert,
            warningMessage,
            errorAlert,
            errorMessage
        }
    } = props
    return<>
        <SingleSnackbar
            severity="success"
            handleClose={hideSuccessAlert}
            open={successAlert}
            message={successAlertMessage}
        />
        <SingleSnackbar
            severity="warning"
            handleClose={hideWarningAlert}
            open={warningAlert}
            message={warningMessage}
        />
        <SingleSnackbar
            severity="error"
            handleClose={hideErrorAlert}
            open={errorAlert}
            message={errorMessage}
        />

    </>
}

export default connect(mapStateToProps,mapDispatchToProps)(Snackbars)